/**
 * 接口命名规范
 *
 * 每一个实体(资源)是一个文件夹,例如邮件资源email.js
 * 文件夹下面创建该接口的所有操作方式
 * http请求方法对应接口函数方法如下:
 * get -> get
 * post -> create
 * put -> update
 * delete -> delete
 * 例如:
 * 获取热门(具有特定含义的)邮件 getHotEmails ,不要在后面再添加list了
 * 获取多封(通用的)邮件 getEmails
 * 获取一封邮件 getEmail
 * 新建邮件,因为添加一封邮件 createEmail
 * 添加,修改,删除多个则采用非restful方式
 */

import request from '@/utils/request';

export function getHotNotices() {
  return request({
    url: '/announcement',
    method: 'GET',
  });
}
